/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */

export type CreateCardAccountRequestCurrency = typeof CreateCardAccountRequestCurrency[keyof typeof CreateCardAccountRequestCurrency];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateCardAccountRequestCurrency = {
  HKD: 'HKD',
  USD: 'USD',
} as const;
